// extracted by mini-css-extract-plugin
export default {"description":"style_description__a8ztB","fade-in":"style_fade-in__0bosJ","image":"style_image__CJI9w"};